var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Listbox } from '@headlessui/react';
import cn from "classnames";
var Select = function (_a) {
    var value = _a.value, onChange = _a.onChange, children = _a.children, className = _a.className, restProps = __rest(_a, ["value", "onChange", "children", "className"]);
    return (_jsx(Listbox, __assign({ className: className, value: value, onChange: onChange }, restProps, { children: children })));
};
var Button = function (_a) {
    var _b, _c, _d;
    var children = _a.children, className = _a.className, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.error, error = _f === void 0 ? false : _f, onClick = _a.onClick, rightElement = _a.rightElement;
    return (_jsxs(Listbox.Button, __assign({ onClick: onClick, className: cn("group border rounded flex h-10 w-full justify-between align-middle font-texts mb-1", (_b = {},
            _b["focus:border-surface-500 border-surface-200 text-surface-700"] = !disabled && !error,
            _b["focus:border-error-500 border-error-500"] = error,
            _b["text-surface-200"] = disabled && !error,
            _b), className) }, { children: [_jsx("div", __assign({ className: cn('py-1.5 px-2 align-middle h-full overflow-hidden truncate font-texts flex items-center', (_c = {}, _c["text-error-500"] = error, _c)) }, { children: _jsxs("div", __assign({ className: 'flex' }, { children: [rightElement, children] })) })), _jsx("span", __assign({ className: cn('order-last font-icons-solid text-lg text-center h-full p-2 rounded-s-none rounded-e border-l cursor-pointer ', (_d = {},
                    _d['group-focus:border-surface-500 bg-surface-100'] = !disabled && !error,
                    _d['border-surface-200 bg-surface-200 text-surface-900 opacity-50'] = disabled && !error,
                    _d['group-focus:border-error-500 border-error-500 bg-error-100'] = error,
                    _d)) }, { children: "expand_more" }))] })));
};
var Options = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, restProps = __rest(_a, ["children", "className", "disabled"]);
    return (_jsx(Listbox.Options, __assign({ className: cn("rounded-lg w-full shadow overflow-auto font-texts p-1 my-0", (_b = {},
            _b["hidden"] = disabled,
            _b), className) }, restProps, { children: children })));
};
var Option = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.as, as = _d === void 0 ? 'div' : _d, value = _a.value, onClick = _a.onClick;
    return (_jsx(Listbox.Option, __assign({ onClick: onClick, className: cn("font-texts p-3 rounded hover:bg-surface-100 cursor-default flex items-center justify-between", (_b = {},
            _b["text-surface-200"] = disabled,
            _b["text-surface-700"] = !disabled,
            _b['hover:bg-transparent'] = disabled,
            _b), className), disabled: disabled, as: as, value: value }, { children: children })));
};
Select.Button = Button;
Select.Options = Options;
Select.Option = Option;
export default Select;
//# sourceMappingURL=Select.js.map